import {gql} from 'apollo-angular';


export const emailsGql = gql`
query ReloadEmailsQuery($participantId: [Int!]) {
  Participant (participantId: $participantId){
    participantId
    event {
      eventId
    }
    individualConstituent {
      constituentEmails {
         constituentEmailId
         email
         primaryFl
         emailType {
           cmgmtEmailTypeId
           name
           description
         }
       }
    }
  }
}
`;